import React from "react";
import { Link } from "react-router-dom";

const contentPages = [
  { to: "/", label: "דף הבית" },
  { to: "/orech-din-beer-sheva", label: "עורך דין בבאר שבע" },
  { to: "/orech-din-taaruva", label: "עורך דין תעבורה" },
  { to: "/yipui-koach-metumshach", label: "ייפוי כוח מתמשך" },
  { to: "/services/litigation", label: "ליטיגציה" },
  { to: "/services/real-estate", label: "נדל״ן" },
  { to: "/services/torts", label: "נזיקין" },
  { to: "/services/family", label: "דיני משפחה" },
  { to: "/services/commercial", label: "משפט מסחרי" },
  { to: "/services/insolvency", label: "חדלות פירעון" },
  { to: "/services/enforcement", label: "הוצאה לפועל" },
];

const Footer = () => {
  return (
    <div className="shane_tm_section">
      <div className="shane_tm_copyright">
        <div className="container">
          <div className="inner">
            <nav className="footer_links" aria-label="דפי תוכן">
              <ul>
                {contentPages.map((page) => (
                  <li key={page.to}>
                    <Link to={page.to}>{page.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
            <p>כל הזכויות שמורות. משרד עו״ד וידבסקי ושות׳ &copy;</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
